import { render } from "./InvoicesFilter.vue?vue&type=template&id=623277b4"
import script from "./InvoicesFilter.vue?vue&type=script&lang=js"
export * from "./InvoicesFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__